import script from "./handlingTrace.vue?vue&type=script&setup=true&lang=js"
export * from "./handlingTrace.vue?vue&type=script&setup=true&lang=js"

import "./handlingTrace.vue?vue&type=style&index=0&id=ac6e8598&lang=scss&scoped=true"
import "./handlingTrace.vue?vue&type=style&index=1&id=ac6e8598&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6e8598"]])

export default __exports__